/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ goods: NonNullable<unknown> }} Carrier_Form_Cod_Override_Below_GoodsInputs */

const vi_carrier_form_cod_override_below_goods = /** @type {(inputs: Carrier_Form_Cod_Override_Below_GoodsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số thu hộ thấp hơn tiền hàng còn nợ (${i?.goods}đ), kiểm tra lại trước khi gửi.`)
};

/**

* @param {Carrier_Form_Cod_Override_Below_GoodsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_below_goods = /** @type {((inputs: Carrier_Form_Cod_Override_Below_GoodsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_Below_GoodsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_below_goods(inputs)
});